





































































import {
    computed,
    defineComponent,
    ref,
    watch,
} from '@vue/composition-api';
import {
    isMobileLayout,
    useVueRouter,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import authStore from '@store/modules/data/authentication/authenticationIndex';
import {
    SdsIcon,
    SdsContentLoader,
    SdsFlag,
    SdsDrawerSelect,
} from '@superbet-group/web.lib.ui-components';
import { useClickOutside } from '@app/utils/useClickOutside';
import { getLocaleRedirectUrl } from '@app/localization/setLocale';
import { SelectableLocale } from '@src/config/shell/localConfigTypes';
import { appLocale } from '@src/config/locale';
import { UserService } from '@core/services/user/UserService';
import { errorGuard } from '@utils/ErrorGuard';
import { SiteLanguageConfig } from '@modules/app/siteLanguage/siteLanguageConfig';
import { localeDisplayName } from '@src/app/utils/locale';

export default defineComponent({
    name: 'LanguageSwitcher',
    setup() {
        const { route } = useVueRouter();

        const authModule = useVuexStore<typeof authStore>('data/authentication');
        const localeOptionsConfig = SiteLanguageConfig.availableLocales;
        const selectedLocale = ref(appLocale.locale);
        const selectedLocaleObject = ref(SiteLanguageConfig.availableLocales.find((locale) => locale.value === appLocale.locale));
        const showLocaleOptions = ref(false);
        const dropdownRef = ref<HTMLElement | null>(null);
        const { isClickOutside } = useClickOutside(dropdownRef);
        const user = authModule.getter('user');
        const setUserData = authModule.action('setUserData');
        const isLoading = ref(false);

        watch(isClickOutside, (newValue) => {
            if (newValue) {
                showLocaleOptions.value = false;
            }
        });

        function toggleDropdown() {
            showLocaleOptions.value = !showLocaleOptions.value;
        }

        async function selectLocale(locale: SelectableLocale) {
            if (selectedLocale.value === locale.value) {
                return;
            }
            showLocaleOptions.value = false;
            await errorGuard(async () => {
                if (user.value) {
                    isLoading.value = true;
                    await UserService.getInstance().setLocale(locale.value);

                    // because local storage user must be in sync
                    setUserData({
                        key: 'locale',
                        value: locale.value,
                    });
                }
                selectedLocale.value = locale.value;
                selectedLocaleObject.value = locale;
                window.location.href = getLocaleRedirectUrl(locale.value, route.value.path).href;
            });
            isLoading.value = false;
        }

        function isLocaleSelected(locale: SelectableLocale) {
            return selectedLocale.value === locale.value;
        }

        const drawerOptions = localeOptionsConfig.map((locale) => ({
            name: localeDisplayName[locale.value],
            value: locale.value,
        }));

        return {
            localeOptions: localeOptionsConfig,
            selectedLocale,
            selectedLocaleObject,
            showLocaleOptions,
            dropdownRef,
            drawerOptions,
            selectLocale,
            toggleDropdown,
            isLocaleSelected,
            isMobile: computed(() => isMobileLayout()),
            localeDisplayName,
            isLoading,
        };
    },
    components: {
        SdsFlag,
        SdsIcon,
        SdsContentLoader,
        SdsDrawerSelect,
    },
});
